import { countries_options } from "@/components/Form/CountryPhone/data";
import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { preprocessTextAsyncAutocompleteField } from "@/features/FormCard/utils";
import { z } from "zod";
import { useTranslation } from "react-i18next";

const filterK2IssuersSchema = z.object({
  name_contains: z
    .preprocess(preprocessTextAsyncAutocompleteField, z.string())
    .optional()
    .nullable(),
  country_contains: z.string().optional(),
  sector_contains: z.string().optional(),
});

export type FilterK2IssuersSchema = z.infer<typeof filterK2IssuersSchema>;

export function FilterK2Issuers() {
  const { t, i18n } = useTranslation(["common", "tables"]);
  const client = "k2";
  const tableName = "k2_issuers";
  const language = i18n.language?.startsWith("en") ? "en" : "fr";

  const fields: Field[] = [
    {
      name: "name_contains",
      label: t(`${tableName}.columns.name`, {
        ns: "tables",
        defaultValue: "Name",
      }),
      type: "asyncAutocomplete",
      base_url: "k2/k2_issuers",
      column_name: "name",
    },
    {
      name: "country_contains",
      label: t(`${tableName}.columns.country_name`, {
        ns: "tables",
        defaultValue: "Country",
      }),
      type: "autocomplete",
      options: countries_options,
    },
    {
      name: "sector_contains",
      label: t(`${tableName}.columns.sector`, {
        ns: "tables",
        defaultValue: "Sector",
      }),
      type: "select",
      useTranslation: true,
      client,
      table_name: tableName,
      language,
      translate_key: "sector",
    },
  ];

  return (
    <FilterTable
      client={client}
      schema={filterK2IssuersSchema}
      tableName={tableName}
      fields={fields}
    />
  );
}
